import { useQuery } from "@tanstack/react-query";
import PleaseWait from "components/loader/PleaseWait";
import { getTrailerEmbedCode } from "lib/client/movieinfo";
import { MouseEventHandler } from "react";
import styles from "./TrailerPlayer.module.css";

//#region [Props]
type TrailerPlayerProps = {
    clipId: string;
    trailerClose: MouseEventHandler
};
//#endregion

//#region [Component]
export default function TrailerPlayer({ clipId, trailerClose }: TrailerPlayerProps) {

    const { isLoading, isError, data, error } = useQuery({
        queryKey: ["trailer", clipId], // key
        queryFn: () => getTrailerEmbedCode(clipId), // loader function

        refetchOnWindowFocus: false,
        staleTime: 599999,
    } // options
    );

    return (
        <div className={styles.STrailerContainer} onClick={trailerClose}>
            <button className={styles.SClose} onClick={trailerClose}>Lukk trailer</button>
            <div className={styles.STrailerSizeRestrictor}>
                {isLoading && <PleaseWait />}
                {!isLoading && data && <div dangerouslySetInnerHTML={{ __html: data }}></div>}
            </div >
        </div>);

}
//#endregion